<template>
    <div class="widget">
        <div class="ddos-widget-header">
            <h3 class="mb-1">{{ $t('ddos_attacks.title') }}</h3>
        </div>
        <div class="alert alert-warning mb-0" role="alert">
            {{$t('ddos_attacks.description')}}
        </div>
        <div class="widget-body" style="overflow-x: auto;">
            <div class="input-group mb-4 border rounded-pill p-1 float-right" style="">
                <div class="m-auto"><i class="fa fa-search"></i>
                </div>
                <input type="search" v-model="search" :placeholder="$t('ddos_attacks.search_placeholder')" class="form-control bg-none border-0">
            </div>

            <table class="table table-striped first-td-padding ddos-attack-table">
                <thead>
                    <tr style="white-space: nowrap;">
                        <td>{{$t('ddos_attacks.table.vm_id')}}</td>
                        <td>{{$t('ddos_attacks.table.description')}}</td>
                        <td>{{$t('ddos_attacks.table.severity')}}</td>
                        <td>{{$t('ddos_attacks.table.status')}}</td>
                        <td>{{$t('ddos_attacks.table.from')}}</td>
                        <td>{{$t('ddos_attacks.table.duration')}}</td>
                    </tr>
                </thead>
                <tbody >
                    <template v-for="(item, key) in filteredAnomalies" 
                        :id="key">
                    <tr v-on:click="getAnomalie(item.anomaly_id)">
                        <td>{{item.vm_id}}</td>
                        <td>{{item.description}}</td>
                        <td>
                            <span class="badge badge-pill" 
                                :class="{
                                    'badge-success': (parseInt(item.severity) < 275),
                                    'badge-warning': (parseInt(item.severity) > 275 && parseInt(item.severity) < 750),
                                    'badge-danger': (parseInt(item.severity) > 750 )}">
                                    {{parseInt(item.severity)}}
                            </span>
                        </td>
                        <td>{{item.status}}</td>
                        <td>{{new Date(item.from).toLocaleString()}}</td>
                        <td>{{item.duration}} {{ $t('ddos_attacks.unit') }}</td>
                    </tr>
                    
                    <tr v-show="anomaly.id == item.anomaly_id">
                        <td colspan="6">
                            <div slot="title">{{anomaly.anomaly}}</div>
            <div class="ddos-modal-body">
                <table class="table">
                    <thead>
                        <tr>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{$t('ddos_attacks.table.anomaly_id')}}</td>
                            <td>{{ anomaly.id }} </td>
                        </tr>
                        <tr>
                            <td>{{$t('ddos_attacks.table.duration')}}</td>
                            <td>{{`${anomaly.duration} ${$t('ddos_attacks.unit')}` }} </td>
                        </tr>
                        <tr>
                            <td>{{$t('ddos_attacks.table.bits')}}</td>
                            <td>{{anomaly.bits}} </td>
                        </tr>
                        <tr>
                            <td>{{$t('ddos_attacks.table.packets')}}</td>
                            <td>{{anomaly.packets}} </td>
                        </tr>
                        <tr>
                            <td>{{$t('ddos_attacks.table.bits_ps')}}</td>
                            <td>{{anomaly.bits_ps}} </td>
                        </tr>
                        <tr>
                            <td>{{$t('ddos_attacks.table.pkts_ps')}}</td>
                            <td>{{anomaly.pkts_ps}} </td>
                        </tr>
                        <tr>
                            <td>{{$t('ddos_attacks.table.mitigated')}}</td>
                            <td>{{anomaly.mitigated}} </td>
                        </tr>
                        <tr>
                            <td>{{$t('ddos_attacks.table.classification')}}</td>
                            <td>{{anomaly.classification}} </td>
                        </tr>
                    </tbody>
                </table>
                <img :src="anomaly.graph_url" alt="Anomaly"/>
            </div>
                        </td>
                    </tr>
                    </template>
                </tbody>
            </table>
        </div>
      
    </div>
    
</template>

<script>
import { getAxios } from 'services/ajax'
import store from '../../store'

export default {
    components: {
    },
    data() {
        return {
            search: "",
            anomalies: [],
            anomaly: {
                status: ""
            },
            ddosModal: {
                show: true,
                templates: [],
                selectedIndex: null
            },
        }
    },
    mounted() {
        store.commit('setLoading', true)
        this.getAnomalies();
    },
    methods: {
        getAnomalies(){
            getAxios().get('/configuration/ddos/attacks').then(response => {   
                this.anomalies = response.data;
                store.commit('setLoading', false);
            }).catch(error => {
                console.log('getAnomalies',error);
                store.commit('setLoading', false);
            });
        },
        getAnomalie(id){
                store.commit('setLoading', true);
            getAxios().get(`/configuration/ddos/attack/${id}`).then(response => {   
                this.anomaly = response.data;         
                this.anomaly.id = id;  
                store.commit('setLoading', false);
            }).catch(error => {
                console.log('getAnomalie',error);
            });
        }
        
    },
    computed: {
        filteredAnomalies () {
            return this.anomalies.filter(item => {
                return (
                    item.vm_id == this.search
                    || item.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    || item.duration.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    || item.bits.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    || item.bits_ps.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    || item.packets.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    || item.pkts_ps.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    || item.severity.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    || item.status.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    || new Date(item.from).toLocaleString().toLowerCase().indexOf(this.search.toLowerCase()) > -1
                )
            })
        },
        anomalyChanged(){
            return !!this.anomaly.status
        }
    },
    beforeUpdate() {
        console.log(this.anomaly);
    }
}
</script>
<style>
.ddos-widget-header {
        display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    flex-flow: column;
    align-items: baseline;
    padding: 10px;
    border-bottom: 2px solid #eee;
    font-size: 1.2rem;
    font-weight: 600;
}
.form-control::placeholder {
  font-size: 0.95rem;
  color: #aaa;
  font-style: italic;
}
.ddos-attack-table > tbody > tr{
    cursor: pointer;
}
.ddos-attack-table > tbody > tr:hover{
    background-color: #f5f5f5;
}
.ddos-modal-body{
    overflow: auto;
    height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/attacks/Attacks.vue